export const useAuthQueryKey = () => [
  'session',
]
